import React, { createContext, useContext, useState, useEffect, ReactNode, useMemo, useCallback } from 'react';

interface DisclaimerContextType {
  hasAcceptedDisclaimer: boolean;
  setHasAcceptedDisclaimer: (value: boolean) => void;
  acceptDisclaimer: () => void;
}

const DisclaimerContext = createContext<DisclaimerContextType | undefined>(undefined);

export const useDisclaimer = () => {
  const context = useContext(DisclaimerContext);
  if (context === undefined) {
    throw new Error('useDisclaimer must be used within a DisclaimerProvider');
  }
  return context;
};

interface DisclaimerProviderProps {
  children: ReactNode;
}

export const DisclaimerProvider: React.FC<DisclaimerProviderProps> = ({ children }) => {
  const [hasAcceptedDisclaimer, setHasAcceptedDisclaimer] = useState(false);
  const decidedStorage = sessionStorage;

  useEffect(() => {
    // Controlla se l'utente ha già accettato il disclaimer
    const disclaimerAccepted = decidedStorage.getItem('adultDisclaimerAccepted');
    if (disclaimerAccepted === 'true') {
      setHasAcceptedDisclaimer(true);
    }
  }, []);

  const acceptDisclaimer = useCallback(() => {
    decidedStorage.setItem('adultDisclaimerAccepted', 'true');
    setHasAcceptedDisclaimer(true);
  }, []);

  const value = useMemo(() => ({
    hasAcceptedDisclaimer,
    setHasAcceptedDisclaimer,
    acceptDisclaimer
  }), [hasAcceptedDisclaimer, acceptDisclaimer]);

  return (
    <DisclaimerContext.Provider value={value}>
      {children}
    </DisclaimerContext.Provider>
  );
};
